import axios from "axios";
import { BASEURL } from "@/api/baseurl";

export default async (to, from, next) => {
  const userInfo = localStorage.getItem("userInfo");

  if (!userInfo || userInfo.length === 0) {
    localStorage.removeItem("userInfo");
    return next("/app/sessions/login");
  }

  const token =
    localStorage.getItem("session_token") ||
    sessionStorage.getItem("session_token");

  if (!token) {
    localStorage.removeItem("userInfo");
    return next("/app/sessions/login");
  }

  try {
    const params = new URLSearchParams();
    params.append("validate_session", "done");
    params.append("token", token);

    const response = await axios.post(`${BASEURL}/user/index.php`, params);

    if (response.data.status === "1") {
      return next();
    } else {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("session_token");
      sessionStorage.removeItem("session_token");
      return next("/app/sessions/login?reason=session_terminated");
    }
  } catch (e) {
    // ✅ If validate call fails during an ongoing redirect, just continue
    if (to.path.includes("/login")) return next();
    return next("/app/sessions/login");
  }
};